export interface WuduStep {
  id: number;
  instruction: string;
  detail: string;
  image?: string;
}

export const wuduSteps: WuduStep[] = [
  {
    id: 1,
    instruction: "Niyyah (Intention)",
    detail: "Make the intention in your heart to perform Wudu for the sake of Allah. Say 'Bismillah' (In the name of Allah).",
    image: "niyyah"
  },
  {
    id: 2,
    instruction: "Wash Hands",
    detail: "Wash both hands up to the wrists three times, ensuring water reaches between the fingers.",
    image: "hands"
  },
  {
    id: 3,
    instruction: "Rinse Mouth",
    detail: "Take water into your mouth with your right hand, swirl it around, and spit it out. Do this three times.",
    image: "mouth"
  },
  {
    id: 4,
    instruction: "Rinse Nose",
    detail: "Sniff water gently into your nose with your right hand and blow it out using your left hand. Do this three times.",
    image: "nose"
  },
  {
    id: 5,
    instruction: "Wash Face",
    detail: "Wash your entire face three times, from the hairline to the chin and from ear to ear.",
    image: "face"
  },
  {
    id: 6,
    instruction: "Wash Arms",
    detail: "Wash your right arm up to and including the elbow three times, then do the same for the left arm.",
    image: "arms"
  },
  {
    id: 7,
    instruction: "Wipe Head",
    detail: "Wipe your wet hands over your head, starting from the front to the back and bringing them forward again. Do this once.",
    image: "head"
  },
  {
    id: 8,
    instruction: "Wipe Ears",
    detail: "Wipe the inside of your ears with your index fingers and the back with your thumbs. Do this once.",
    image: "ears"
  },
  {
    id: 9,
    instruction: "Wash Feet",
    detail: "Wash your right foot up to the ankle three times, ensuring water reaches between the toes. Repeat for the left foot.",
    image: "feet"
  },
  {
    id: 10,
    instruction: "Dua (Supplication)",
    detail: "Ash-hadu an la ilaha ill-Allahu wahdahu la sharika lah, wa ash-hadu anna Muhammadan 'abduhu wa rasuluh.",
    image: "dua"
  }
];